import { QueryClient } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./App";

const queryClient = new QueryClient();

const app = (
  <HelmetProvider>
    <BrowserRouter>
      <App queryClient={queryClient} />
    </BrowserRouter>
  </HelmetProvider>
);

const container = document.getElementById("root")!;

if (container.dataset.edgeSsr === "1") {
  // Edge function injected a crawler snapshot that doesn't match React's
  // output (directory pages render live data) → mount fresh over it.
  container.innerHTML = "";
  createRoot(container).render(app);
} else if (container.firstElementChild) {
  // Prerendered/SSG HTML matches React output → hydrate.
  hydrateRoot(container, app);
} else {
  // Plain SPA shell (dev, or non-prerendered routes) → mount fresh.
  createRoot(container).render(app);
}
